function Header({ children }) {
  return (
    <h1 className="quiz-question">
      {children}
    </h1>
  );
}

export default Header;
